<template>
  <div class="user">
    <!-- 搜索区域 -->
    <SiruiSearch
      ref="siruiSearch"
      :query="query"
      :columns="searchColumns"
      @resetBtnClick="resetBtnClick"
      @searchBtnClick="searchBtnClick"
    ></SiruiSearch>
    <!--内容区域-->
    <div class="main-content">
      <sirui-table
        ref="siruiTable"
        :buttonList="menuButtonList"
        :loading="load"
        :data="tableData"
        :paging="true"
        :reserve="false"
        :setting="false"
        :customVisible="false"
        :columns="columnList"
        @chooseClick="chooseClick"
        @handleSizeChange="handleSizeChange"
        @handleCurrentChange="handleCurrentChange"
        @handleSelectionChange="handleSelectionChange"
        @sortChangeEvent="sortChangeEvent"
      >
        <vxe-table-column
          v-for="(item, index) in columnList"
          :key="index"
          :type="item.type"
          :visible="item.visible"
          :fixed="item.fixed"
          :width="item.width"
          :sortable="item.sortable"
          :field="item.field"
          :title="item.title ? $t(item.title) : null"
        >
        </vxe-table-column>
      </sirui-table>
    </div>
    <addMessageTemp v-on:getData="getData" ref="addMessageTemp"></addMessageTemp>
    <editMessageTemp v-on:getData="getData" ref="editMessageTemp"></editMessageTemp>
    <detailMessageTemp v-on:getData="getData" ref="detailMessageTemp"></detailMessageTemp>
    <sendMessage v-on:getData="getData" ref="sendMessage"></sendMessage>
  </div>
</template>
<script>
  import { mapState } from 'vuex';
  import API from '@/api/messageCenter/messageTemp.js';
  import SiruiSearch from '@/components/SiruiSearch';
  import SiruiTable from '@/components/SiruiTable';
  import addMessageTemp from './add';
  import editMessageTemp from './edit';
  import detailMessageTemp from './detail';
  import sendMessage from './sendMessage';
  import tableMixins from '@/common/mixins/table.js';
  export default {
    mixins: [tableMixins],
    components: {
      SiruiTable,
      SiruiSearch,
      addMessageTemp,
      editMessageTemp,
      detailMessageTemp,
      sendMessage,
    },
    name: 'messageTemp',
    data() {
      return {
        load: false,
        userList: [],
        typeList: [],
        query: {
          messageTypeName: null,
        },
        tableData: [],
        rowData: {},
        multipleSelection: [], //存放选中的值

        columnList: [],
        //表格显示字段
        columnListDefault: [
          {
            type: 'checkbox',
            visible: true,
            width: '50',
            fixed: 'left',
          },
          {
            field: 'title',
            title: 'messageType.table.title',
            visible: true,
            // sortable: true
          },
          { field: 'messageTypeName', title: 'messageType.table.messageTypeName', visible: true },
          { field: 'content', title: 'messageType.table.content', visible: true },
          { field: 'gmtCreate', title: 'messageType.table.gmtCreate', visible: true },
        ],
        menuButtonList: [],
      };
    },
    computed: {
      //搜索字段
      searchColumns() {
        return [
          {
            prop: 'messageTypeId',
            name: this.$t('messageType.search.messageTypeName'),
            type: 'select',
            placeholder: this.$t('messageType.search.messageTypePlaceholder'),
            options: this.typeList,
          },
        ];
      },
      ...mapState({
        userInfo: (state) => state.userInfo,
      }),
    },

    /**页面必要代码Start */
    mounted() {
      this.getData();
      this.getTypeList();
      this.getButtonList();
      //this.getUserList()
    },
    methods: {
      //获取消息类型列表
      getTypeList() {
        this.$axios.get(API.MESSAGE_TYPE_LIST_API).then((res) => {
          this.load = false;
          if (0 == res.data.code) {
            if (res.data.data.length > 0) {
              res.data.data.map((item) => {
                item.value = item.id;
                item.label = item.messageTypeName;
              });
            }
            this.typeList = res.data.data;
          } else {
            this.$message({
              showClose: true,
              message: res.data.msg,
              type: 'error',
            });
          }
        });
      },
      //点击按钮触发的方法
      chooseClick(type) {
        //新增
        if (type === 'add') {
          this.$refs.addMessageTemp.openDialog(true);
        } else if (type === 'del') {
          //删除
          this.delMessageTemp();
        } else if (type == 'sendMessage') {
          this.sendMessage();
        } else {
          this.edit();
        }
      },
      //修改
      edit() {
        if (this.multipleSelection.length === 0) {
          this.noSelectData();
        } else if (this.multipleSelection.length > 1) {
          this.onlyOneSelect();
        } else {
          this.$refs.editMessageTemp.openDialog(true, this.multipleSelection[0].id);
        }
      },
      //发送新消息
      sendMessage() {
        if (this.multipleSelection.length === 0) {
          this.noSelectData();
        } else if (this.multipleSelection.length > 1) {
          this.onlyOneSelect();
        } else {
          this.$refs.sendMessage.openDialog(true, this.multipleSelection[0].id);
        }
      },
      //双击查看详情
      dblclickRow(row) {
        this.$refs.detailMessageTemp.openDialog(true, row);
      },
      //单击选中某一行
      clickRow(row) {
        this.rowData = row;
      },
      //删除
      delMessageTemp() {
        if (this.multipleSelection.length === 0) {
          this.noSelectData();
        } else if (this.multipleSelection.length > 1) {
          this.onlyOneSelect();
        } else {
          this.$confirmAction()
            .then(() => {
              this.$axios
                .post(API.MESSAGE_TEMP_DEL_API, {
                  id: this.multipleSelection[0].id,
                  version: this.multipleSelection[0].version,
                })
                .then((res) => {
                  if (0 == res.data.code) {
                    //删除成功
                    this.getData();
                    this.$message({
                      type: 'success',
                      message: this.$t('message.delSuccess'),
                    });
                  } else {
                    this.$message({
                      showClose: true,
                      message: res.data.msg,
                      type: 'error',
                    });
                  }
                });
            })
            .catch(() => {
              this.$message({
                type: 'info',
                message: this.$t('message.cancle'),
              });
            });
        }
      },
      //获取数据
      getData() {
        const query = this.$refs.siruiSearch.query;
        query.pageSize = this.$refs.siruiTable.page.pageSize;
        query.pageNum = this.$refs.siruiTable.page.pageNum;
        this.load = true;
        this.$axios.post(API.MESSAGE_TEMP_LIST_API, query).then((res) => {
          this.load = false;
          if (0 == res.data.code) {
            this.tableData = res.data.data.list;
            this.$refs.siruiTable.setPageTotal(res.data.data.total);
          } else {
            this.$message({
              showClose: true,
              message: res.data.msg,
              type: 'error',
            });
          }
        });
      },
      //调用接口排序
      sortChangeEvent({ column, property, order }) {
        console.info(column, property, order);
      },
      //没有选择数据提示
      noSelectData() {
        this.$message({
          showClose: true,
          message: this.$t('xTable.noSelectData'),
          type: 'error',
        });
      },
      onlyOneSelect() {
        this.$message({
          showClose: true,
          message: this.$t('xTable.onlyOneSelect'),
          type: 'error',
        });
      },
      /**页面必要代码End */
    },
  };
</script>
<style lang="scss" scoped>
  .user {
    height: 100%;
    box-sizing: border-box;
  }
</style>
